var map = {
	"./fr-BE.json": [
		55010,
		5010
	],
	"./nl-BE.json": [
		52484,
		2484
	],
	"./nl-NL.json": [
		6615,
		6615
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 908;
module.exports = webpackAsyncContext;